export const EVENTS = {
  LOADING: {
    START: 'loading.start',
    FINISH: 'loading.finish',
  }
};